import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TextStrikethroughFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TextStrikethroughFilled({
  title = 'Text strikethrough',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title === undefined ? <title id={titleId}>{'Text strikethrough'}</title> : title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor">
        <path d="M10.5 10C9.6 9.5 9 8.6 9 7.5 9 5.9 10.8 5 12.5 5c2.4 0 3.2 2 3.4 3H19c-.3-2-2-6-6.5-6C9.3 2 6 4.1 6 7.5c0 .9.2 1.7.6 2.5H2v3h20v-3H10.5ZM15.9 15c.1.4.1.9.1 1.5 0 1.2-1.4 2.5-3.5 2.5-2.2 0-3.7-1.8-4-3h-3v.2c.4 2.8 3.1 5.8 7 5.8 4 0 6.5-2.9 6.5-5.5 0-.6 0-1-.1-1.5h-3Z" />
      </g>
    </svg>;
}) as ForwardedIconComponent);
export default TextStrikethroughFilled;